import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../../transactions/pages/list/models/params.model';
import { UserService } from '../../../../../../core/services/user.service';
import { ServicesLogosService } from '../../../../../../core/services/services-logos.service';
import { FlowAuthorizationSchemeModalComponent } from '../modals/flow-authorization-scheme-modal/flow-authorization-scheme-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ServicesService } from 'src/app/contexts/services/services.service';
import { AuthorizationSchemeService } from 'src/app/contexts/snapshot/authorization_scheme.service';

@Component({
  selector: 'app-flow-autorization-scheme',
  templateUrl: './flow-autorization-scheme.component.html',
})
export class
  FlowAuthorizationSchemeComponent implements OnInit {

  @Input() flow_order: any;
  @Input() expandedStepState;
  @Input() authorization_scheme;
  @Input() onlyViewer;
  @Output() removeAS = new EventEmitter();

  model: any = {};
  params: Params;

  constructor(private route: ActivatedRoute,
    private dialog: MatDialog,
    private authorizationSchemeService: AuthorizationSchemeService,
    private serviceService: ServicesService,
    private ServicesLogosService: ServicesLogosService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.model.user = this.userService.user;
    this.authorization_scheme.steps.forEach(step => {
      if (step) {
        if (step.first_service) {
          if (step.first_service.name)
            step.first_service.image_path = this.ServicesLogosService.getLogo(step.first_service);
        }
        if (step.second_service) {
          if (step.second_service.name)
            step.second_service.image_path = this.ServicesLogosService.getLogo(step.second_service);
        }
        if (step.third_service) {
          if (step.third_service.name)
            step.third_service.image_path = this.ServicesLogosService.getLogo(step.third_service);
        }
      }
    });

    this.route.paramMap.subscribe((params) => {
      this.params = new Params(params);
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });

  }
  remove(event: any) {
    this.removeAS.emit();
    event.stopPropagation();
  }

  editStep(event: any) {
    event.stopPropagation();
  }

  openAs() {
    event.stopPropagation();

    this.serviceService.filter(this.model.partner, this.model.account, ['G'], true).subscribe(response => {
      this.model.servicesAs = response.services.filter(p => p.active);
      this.images();

      const myClonedArray = [];
      this.model.servicesAs.forEach(val => myClonedArray.push(Object.assign({}, val)));

      const myClonedArray2 = [];
      this.model.servicesAs.forEach(val => myClonedArray2.push(Object.assign({}, val)));

      const myClonedArray3 = [];
      this.model.servicesAs.forEach(val => myClonedArray3.push(Object.assign({}, val)));

      this.authorizationSchemeService.get(this.model.partner, this.model.account, this.authorization_scheme.id).subscribe(as => {
        as.authorization_scheme.can_edit = as.can_edit;

        as.authorization_scheme.steps.forEach(step => {
          step.first_service.services = myClonedArray;
          if (!step.second_service) {
            step.second_service = {};
          }
          if (!step.third_service) {
            step.third_service = {};
          }

          step.second_service.services = myClonedArray2;

          step.third_service.services = myClonedArray3;

        });

        const dialog = this.dialog.open(FlowAuthorizationSchemeModalComponent, {
          width: '990px',
          data: {
            partner: this.model.partner,
            account: this.model.account,
            authorization_scheme: as.authorization_scheme,
            services: this.model.servicesAs
          },
          autoFocus: false
        });

        dialog.afterClosed().subscribe(result => {
          if (result) {
            if (result.createOrEditing == 'creating')
              this.model.authorization_schemes.push(result.response.authorization_scheme);
            else {
              var find = this.model.authorization_schemes.find(p => p.id == result.response.authorization_scheme.id);
              let index = this.model.authorization_schemes.indexOf(find);
              this.model.authorization_schemes[index] = result.response.authorization_scheme;
            }
          }
        });
      },
        (error) => {
          if (error.result.length > 0) {
            error.result.forEach(element => {
            });
          }
        });
    });
  }


  images() {
    if (this.model.servicesAs.length > 0) {
      this.model.servicesAs.forEach(async element => {
        element.image_path = await this.ServicesLogosService.getLogo(element);
      });
    }
  }

}
